import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { strings } from "@/content/strings";

const KEY = "apex_doors_lang";
const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" && window.localStorage.getItem(KEY);
    return stored === "en" || stored === "ar" ? stored : "ar";
  });

  useEffect(() => {
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
    document.documentElement.setAttribute("data-lang", lang);
    window.localStorage.setItem(KEY, lang);
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      dir: lang === "ar" ? "rtl" : "ltr",
      isRtl: lang === "ar",
      t: strings[lang],
      toggle: () => setLang((l) => (l === "ar" ? "en" : "ar")),
    }),
    [lang],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
